var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Notifications'),(_vm.user.auth)?_c('div',{attrs:{"id":"nav"}},[_c('Nav')],1):_vm._e(),_c('b-container',{staticClass:"mt-5"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }